import React from 'react';
import { cn } from '../../lib/utils';

export default function PoweredByFooter({ className }) {
  return (
    <div className={cn('flex items-center justify-center py-4', className)}>
      <span className="text-xs text-on-surface-variant/60">Powered By </span>
      <span className="text-xs font-semibold text-primary-600 ml-1">Crescent Technologies</span>
    </div>
  );
}
